export default {
  title: 'Tablet fedeltà',
  headers: {
    customer_frequency: 'Frequenza clienti',
  },
};
